<div class="modal-dialog modal-dialog-centered modal-lg" style="padding: 0">
  <div class="modal-content">
    <div class="modal-body" style="padding: 30px 30px 20px 30px">
      <div class="limite-registros-container">
        <h5 style="font-weight: 700; margin-bottom: 16px">
          <span style="color: #f0ad4e; margin-right: 8px">⚠</span>
          <span>{{ 'record.maxSizeReached' | translate }}</span>
        </h5>

        <p
          style="
            font-size: 14px;
            color: #333;
            margin-bottom: 12px;
            line-height: 1.5;
          "
        >
          <span
            [innerHTML]="
              'record.actualDownloadSize'
                | translate : { total: cantidadRegistros | number }
            "
          ></span>
        </p>

        <p
          style="
            font-size: 14px;
            color: #333;
            margin-bottom: 0;
            line-height: 1.5;
          "
        >
          {{ 'record.continueDownload' | translate }}
        </p>
      </div>
    </div>

    <div
      class="modal-footer"
      style="
        display: flex;
        gap: 12px;
        padding: 16px 30px 24px 30px;
        border-top: 1px solid #e9ecef;
      "
    >
      <button
        class="btn btn-primary"
        style="flex: 1; padding: 10px 20px; font-weight: 600"
        (click)="cancel()"
      >
        {{ 'record.adjustFilters' | translate }}
      </button>
      <button
        class="btn btn-outline-primary"
        style="flex: 1; padding: 10px 20px; font-weight: 500"
        (click)="continuar()"
      >
        {{ 'record.continueDownloading' | translate }}
      </button>
    </div>
  </div>
</div>
